import React, { useEffect } from 'react'
import { ConnectCreateGroupOverlay } from '@fs/zion-group-management'
import { useOverlay } from '@fs/zion-ui'
import { useHistory } from '@fs/zion-router'
import { usePageView } from '@fs/zion-analytics'

export default function ConnectCreatePage() {
  usePageView({ page_detail: 'Connect' }) // page_detail updates link_page for all analytics past this point

  const overlay = useOverlay({ initiallyOpen: true })
  const history = useHistory()

  useEffect(() => {
    if (!overlay.isOpen && !overlay.transitioning) {
      history.push('/connect-create/done')
    }
  }, [overlay.isOpen, overlay.transitioning, history])

  return <ConnectCreateGroupOverlay overlay={overlay} preferNativeShare />
}
